module.exports = __webpack_public_path__ + "img/book3.75da7ff2.jpg";